module.exports = __webpack_public_path__ + "img/winerack37.21f3c68c.jpg";